<script setup>
    import { useNotificationStore } from '@/stores/NotificationStore.js'
    import {ref, onMounted, watch, computed} from 'vue'

    const notificationStore = useNotificationStore()
    const emit = defineEmits(['defaultCalendarSelected'])

    const calendarId = ref(null)
    const calendars = ref([])
    const currentDefaultCalendarId = ref(null)
    const loading = ref(false)
    const calendarsHasMultipleProfiles = ref(false)

    const loadCalendars = async () => {
        loading.value = true
        const res = await axios.get(route('integrations.cronofy.index'))
        calendars.value = res.data.calendars
        currentDefaultCalendarId.value = res.data.currentDefaultCalendarId

        if (res.data.currentDefaultCalendarId) {
            emit('defaultCalendarSelected', res.data.currentDefaultCalendarId)
        } else if (writableCalendars.value.length > 0) {
            calendarId.value = writableCalendars.value[0].calendar_id
        }
        loading.value = false
    }

    const saveCalendar = async () => {
        const res = await axios.post(route('integrations.cronofy.store_calendar'), {
            calendar_id: calendarId.value,
        })

        if (res.data.success) {
            currentDefaultCalendarId.value = calendarId.value
            emit('defaultCalendarSelected', calendarId.value)
            notificationStore.addNotification({
                type: 'success',
                title: _mft('cronofy:calendarSavedNotification.title') + '!',
                message: _mft('cronofy:calendarSavedNotification.message'),
                dismissAfter: 2500,
            })
        }
    }

    const disableCalendarSync = async () => {
        const res = await axios.delete(route('integrations.cronofy.delete'));
        window.location.reload();
    }

    const writableCalendars = computed(() => {
        return calendars.value.filter(calendar => !calendar.calendar_readonly)
    })

    watch(calendarId, () => {
        saveCalendar()
    })

    onMounted(() => {
        loadCalendars()
    })

</script>
<template>
    <div>
        <div class="flex justify-center">
            <mf-spinner-medium v-if="loading" class="w-12 h-6"></mf-spinner-medium>
        </div>
        <card-sub
            v-if="! currentDefaultCalendarId && ! loading"
            style-type="danger"
            class="mb-8 text-center"
        >
            {{ _mft('cronofy:defaultCalendarNotSelected') }}
        </card-sub>


        <h3 v-if="! loading">
            {{ _mft('cronofy:defaultCalendarForMeetingBookings') }}
        </h3>
        <div
            v-if="writableCalendars.length === 0 && ! loading"
            class="py-2"
        >
            No calendars with write access found. Check you calendars, or delete the calendar integration and start over.
            <div class="flex justify-center mt-2">
                <button-danger
                    @click="disableCalendarSync"
                >Delete calendar integration</button-danger>
            </div>
        </div>

        <ul class="divide-y">
            <li
                v-for="(calendar, i) in writableCalendars"
                :key="i"
                class="my-1 py-1 flex justify-between space-x-4 items-center"
            >
                <div>
                    <div :class="currentDefaultCalendarId === calendar.calendar_id ? 'font-bold' : ''">
                        {{ calendar.calendar_name }}

                    </div>
                    <div class="text-xs text-gray-400">
                        {{ _mft('cronofy:fromAccount') }} {{ calendar.profile_name }}
                    </div>
                </div>
                <button-base
                    v-if="! calendar.calendar_readonly"
                    :style-type="calendarId === calendar.calendar_id || currentDefaultCalendarId === calendar.calendar_id ? 'tinted' : 'secondary'"
                    @click="calendarId = calendar.calendar_id"
                >{{ calendarId === calendar.calendar_id || currentDefaultCalendarId === calendar.calendar_id ? _mft('cronofy:defaultCalendarSelected') : _mft('cronofy:defaultCalendarSelect') }}</button-base>
            </li>
        </ul>
    </div>
</template>
